import axios from "../../../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/translation/BatchTranslatePrompt/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/translation/BatchTranslatePrompt/edit",
        {id:params}
    )
}
function SUBMIT_ADD(params) {
    return  axios.post("/translation/BatchTranslatePrompt/addPost",{...params} )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/translation/BatchTranslatePrompt/editPost",{...params} )
}


function DELE(params) {
    return  axios.get("/translation/BatchTranslatePrompt/delete",{
        params: {
            ids:params
        }
    } )
}
function GET_LISTS(params) {
    return axios.get("/translation/BatchRewritePrompt/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATAS(params) {
    return  axios.post("/translation/BatchRewritePrompt/edit",
        {id:params}
    )
}
function SUBMIT_ADDS(params) {
    return  axios.post("/translation/BatchRewritePrompt/addPost",{...params} )
}

function SUBMIT_EDITS(params) {
    return  axios.post("/translation/BatchRewritePrompt/editPost",{...params} )
}


function DELES(params) {
    return  axios.get("/translation/BatchRewritePrompt/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    GET_LISTS,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    DELE,
    EDIT_DATAS,
    SUBMIT_ADDS,
    SUBMIT_EDITS,
    DELES,
}
